<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        title="MaterialDelivery"
        :height="height"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreMaterial/MaterialDelivery/MaterialDeliveryDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
      <template v-slot:item.registration="{ item }">
        <router-link
            v-if="!!item.opened"
            :to="{name:'MaterialStepperQR', params: { selectedDeliveryUid: item.uid}}"
        >
          <v-icon small color="edit_icon" class="d-flex justify-center">mdi-plus-box-multiple-outline</v-icon>
        </router-link>
      </template>
      <template v-slot:item.provider__name="{ item }">
        <span v-if="!!item.provider_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.provider_uid]">
          {{ storeAggregate.rootData[item.provider_uid].name }}
        </span>
      </template>
      <template v-slot:item.material_owner__name="{ item }">
        <span
            v-if="!!item.material_owner_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.material_owner_uid]">
          {{ storeAggregate.rootData[item.material_owner_uid].name }}
        </span>
      </template>
      <template v-slot:item.usage_restriction__name="{ item }">
        <span
            v-if="!!item.usage_restriction_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.usage_restriction_uid]">
          {{ storeAggregate.rootData[item.usage_restriction_uid].name }}
        </span>
      </template>
      <template v-slot:item.customer_order__name="{ item }">
        <router-link
            v-if="!!item.customer_order_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.customer_order_uid]"
            :to="{name:'CustomerOrderDetail', params: { uidItem: item.customer_order_uid}}"
        >
          {{ storeAggregate.rootData[item.customer_order_uid].name }}
        </router-link>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import MaterialDeliveryDetail from "@/components/CoreMaterial/MaterialDelivery/MaterialDeliveryDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";

export default {
  name: "MaterialDeliveryTable",

  props: {
    embedded: {default: false},
    height: {default: null},
    storeName: {type: [String], default: 'MaterialDeliveryTable'},
    dtoDetailQuery: {default: 'MaterialDeliveryDetailQueryDTO'},
    detailStoreName: {default: 'MaterialDeliveryDetail'},
    dtoValidateCommand: {type: [String], default: 'MaterialDeliveryValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'MaterialDeliveryListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'MaterialDeliveryActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
    headers: {default: null},
  },

  components: {
    CommonTable,
    MaterialDeliveryDetail,
    BaseFieldCheck,
  },

  methods: {},

  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = this.headers || [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 10},
      {
        text: 'Registration material',
        value: 'registration',
        sortable: false,
        filterable: true,
        divider: true,
        width: 10
      },
      {text: 'Provider', value: 'provider__name', sortable: true, filterable: true, divider: true},
      {text: 'Material owner', value: 'material_owner__name', sortable: true, filterable: true, divider: true},
      {text: 'Usage restriction', value: 'usage_restriction__name', sortable: true, filterable: true, divider: true},
      {text: 'Delivery number', value: 'delivery_number', sortable: true, filterable: true, divider: true},
      {text: 'Mandatory PN', value: 'mandatory_pn', sortable: true, filterable: true, divider: true, type: 'bool'},
      {text: 'Opened', value: 'opened', sortable: true, filterable: true, divider: true, type: 'bool'},
      {text: 'Customer order', value: 'customer_order__name', sortable: true, filterable: true, divider: true, width: 200},
      {text: 'Edited by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'Edited on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'Created by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'Created on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'Saved', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 10},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeAggregate) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.options.sortBy = ['edited_on']
    }
  },

  data() {
    return {
      storeAggregate: null,
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreMaterial/locales.json">
</i18n>